import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import pathBuilder from '@/api/utils';
import auth from '@/api/auth';

import {
  BasePacket,
  ApiPacket,
  ApiBadgeWithObjective,
  utils as PacketUtils,
  Badge
} from '@/models/packet';

export default {
  async getPublicPackets(): Promise<[BasePacket, Badge[]][]> {
    const {
      data: { data: results }
    } = await axios.get(pathBuilder.basic('public', 'packets'));

    const apiResults: (ApiPacket & {
      badges: ApiBadgeWithObjective[];
    })[] = camelcaseKeys(results, { deep: true });

    return apiResults.map<[BasePacket, Badge[]]>(p => [
      PacketUtils.convertApiPacket(p, () => true),
      p.badges.map(b => PacketUtils.convertApiBadgeWithObjective(b))
    ]);
  },

  async createUser(idToken: string): Promise<string> {
    const { data: results } = await axios.post(
      pathBuilder.basic('user'),
      auth.buildGrantTypeBody(idToken)
    );

    return results['access_token'];
  }
};
